module.exports = "https://static.zego.com/_next/static/images/LicencePlate-eb0a420ffdd39d6e8217045648f834cf.svg";